export { default as ArrowPathOutlineIcon } from './ArrowPathOutlineIcon';
